<script lang="ts">
  import type {Poem} from '../types'
  import {t} from '../i18n'

  export let poem: Poem

  $: classic = poem.authors[0]
  $: classicLifeYears = [classic?.birth_year, classic?.death_year].filter(Boolean).join(' - ')
</script>

<div class="grid__card grid__card--classic">
  <div class="grid__author-info">
    <a class="portrait-circle" href={classic.link}>
      <img src={classic.avatar_big_thumgb} alt={classic.full_name}/>
    </a>
    <h5>
      <a class="author-name" href={classic.link}>{classic.full_name}</a>
    </h5>

    {#if classicLifeYears}
      <div class="lifetime italic">({classicLifeYears})</div>
    {/if}
  </div>

  <div class="grid__short-wrap">
    <h4>
      <a href={`/poems/${poem.handle}`}>{poem.title}</a>
    </h4>
    <div class="grid__short grid__short--classic">
      {@html poem.preview}
    </div>
  </div>

  {#if poem.read_more}
    <a class="italic continue" href={`/poems/${poem.handle}`}>{t.poem.continue_reading}</a>
  {/if}

  <hr class="full-width"/>
  <div class="soc-actions">
    <div class="soc-item views">
      <i class="icon-p icon-p-eye"></i>
      {poem.views_count}
    </div>
    <div class="soc-item likes">
      <i class="icon-p icon-p-like"></i>
      {poem.likes_count}
    </div>
  </div>
</div>
